Mixins.deleteImage = {
    methods: {
        deleteImage(images, image, inputID) {
            images.splice(images.indexOf(image), 1);
            document.getElementById(inputID).value = null;
        }
    }
};